import { Box } from "@mui/system";
import * as React from "react";
import {
  DataGrid,
  GridColDef,
  GridValueGetterParams,
  GridToolbar,
  GridCellEditCommitParams,
  MuiEvent,
} from "@mui/x-data-grid";
import { useState, useEffect } from "react";
import pdf from "../../assets/PdfIcon.svg";

import PaymentReceipts from "../../stores/PaymentReceiptsStore";
import User from "../../stores/UserStore";

import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { MobileDatePicker } from "@mui/x-date-pickers/MobileDatePicker";
import { Modal, TextField, TextFieldProps } from "@mui/material";
import { ButtonSecondary } from "../../screens/login.screen/login.styled";
import { createRoot } from "react-dom/client";
import { Spinner } from "../../components/SpinnerRaw/SpinnerRaw";

import "./temp.css";
import CardsPopup from "../MoveOutTerminationTabs/CardsPopup";
import { autoAction } from "mobx/dist/internal";
import General from "../../stores/GeneralStore";
import { observer } from "mobx-react";
import { toJS } from "mobx";
import { NotifyError } from "../../utils/ShowError";
import AccountsNotifications from "../../stores/AccountsNotificationsStore";
import "./style.css";
import MobileDataGrid from "./MobileDataGrid";
import moment from "moment";
import { GatewaySelection } from "../MoveOutTerminationTabs/GatewaySelection";
import paymentReceiptsStore from "../../stores/PaymentReceiptsStore";
import { ACTIVE_PAYMENT_GATEWAY } from "../../utils/constants";
import CardsStore from "../../stores/CardsStore";
import nocsRequestsStore from "../../stores/NocsRequestsStore";
import {
  areValidAmounts,
  filsToAmount,
  formatFils,
  normalizeAmount,
  sumFils,
} from "../../utils/money";
interface Obj {
  [key: string]: any;
}


interface AppConfig {
  "isCheckout" : boolean
}
const DG = (props?: any) => {
  const [isLargeScreen, setIsLargeScreen] = React.useState(false);

  React.useEffect(() => {
    function handleResize() {
      setIsLargeScreen(window.innerWidth > 991);
    }
    window.addEventListener("resize", handleResize);
    handleResize();
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const [pageSize, setPageSize] = useState<number>(5);
  const [lastBillingId, setLastBillingId] = useState<any>("");
  const [loading, setLoading] = useState(false);
  const [paymentModal, setPaymentModal] = useState(false);

  //fix yesterday date !
  const [fromValue, setFromValue] = useState<any | null>(moment(moment(moment(Date.now()).format("YYYY-MM-DD")).clone().subtract(90, 'days').toDate()).format("YYYY / MM / DD"));
  const [toValue, setToValue] = useState<Date | null>(new Date());

  const [rows, setRows] = useState<Obj[]>([]);
  const [columns, setColumns] = useState<GridColDef[]>([]);

  const [selectedRows, setSelectedRows] = useState<any>([]);
  const [amountToPayArray, setAmountToPayArray] = useState<any[]>([]);
  const isCheckoutActive = ACTIVE_PAYMENT_GATEWAY === 'CHECKOUT';
  const [config, setConfig] = useState<AppConfig | null>(null);
  
  const handleFromChange = (newVal: Date | null) => {
    setFromValue(newVal);
  };

  const handleToChange = (newVal: Date | null) => {
    setToValue(newVal);
  };

  const downloadBillPDF = async (id: string) => {
    //setLoading(true)
    try {
      // await DownloadBill(id);
      const data = { id };
      const res = await AccountsNotifications?.getFileBillHistory({
        errorId: "getFileError",
        data,
      });
      if (res) {
        setLoading(false);
      }
    } catch (error) {
      console.error("Error in downloadPDF:", error);
      setLoading(false);
    }
  };
  const handleGetCardsList = async () => {
  await CardsStore.getCardsList({ errorId: "getCardsListError" });
  };
   useEffect(() => {
    handleGetCardsList();
   },[])

   useEffect(() => {
     async function loadConfig() {
       try {
         const response = await fetch('/config/config.json'); 
         const json = await response.json();
         setConfig(json);
       } catch (err) {
         console.error("Error loading config:", err);
       }
     }
     loadConfig();
   }, []);

  const DownloadPaymentHistory = async (id: string, type: any) => {
    //setLoading(true);
    const data = { id, type };
    const res = await AccountsNotifications.getFilePayments({
      errorId: "getFileError",
      data,
    });
    if (res) {
      setLoading(false)
    }
  };

  const downloadPaymentHistoryPdf = async (id: string) => {
    try {
      await DownloadPaymentHistory(id, "Payments");
    } catch (error) {
      console.error("Error in downloadPaymentHistoryPdf:", error);
    }
  };
  const downloadAccountSummaryPdf = async (id: string, type: string) => {
    //setLoading(true)
    try {
      const data = { id, type };
      const res = await AccountsNotifications.getFileSummary({
        errorId: "getFileError",
        data,
      });
      if (res) {
        setLoading(false);
      }
    } catch (error) {
      console.error("Error in downloadPaymentHistoryPdf:", error);
      setLoading(false);
    }
  };
  const downloadPDCFile = async (id: string, type: string) => {
    //setLoading(true);
    try {
      const data = { id, type };
      const res = await AccountsNotifications.downloadPDCFile({
        errorId: "getFileError",
        data,
      });
      if (res) {
        setLoading(false);
      }
    } catch (error) {
      console.error("Error in downloadPaymentHistoryPdf:", error);
      setLoading(false);
    }
  };

  const handleRowSelection = async (ids: any) => {
    console.log(toJS(rows));
    const selectedRowsData = ids.map((id: any) =>
      rows.find((row) => row.id === id)
    );
    // console.log(toJS(toJS(selectedRowsData)));
    setSelectedRows(selectedRowsData);
    // setSelectedRows(arr);
    // arr.map((index: any) => {
    //   console.log(rows[index - 1]);
    // });
  };

  const loadTable = async () => {
    setLoading(true);
    switch (props.index) {
      case 0:
        setRows([]);
        await PaymentReceipts.getAllPendingPayments({
          errorId: "getPendingPaymentsError",
          data: {
            personId: User.info.personId as string,
            returnAllAccountTypes: "Y",
            accountType: props.selectFilter?.account == "all"? "ALL":props.selectFilter?.account=="Default Account"?"DEFAULT":props.selectFilter?.account=="Connector Account"?"CONNECTOR":props.selectFilter?.account=="UOS"?"UOS":"DEFAULT",
            fullName:
              (General?.codeLabels["cm_pdc_paymentaccounts"]
                ?.languageCode == "ARA"
                ? User?.profile?.arName
                  ? User?.profile?.arName?.trim()?.split(/[,\s]+/)?.slice(0, 3)?.join(' ')
                  : User?.profile?.name?.trim()?.split(/[,\s]+/)?.slice(0, 3)?.join(' ')
                : (User?.profile?.name?.trim()?.split(/[,\s]+/)?.slice(0, 3)?.join(' ') as string)) as string,
          },
        });
        setColumns(pendingColumns);
        const firstFilter = props.selectFilter?.account != null && props.selectFilter?.account != "all" ?
          PaymentReceipts?.pendingPayments?.filter((payment) => {
            const searchString = props.selectFilter?.account?.toLowerCase(); // Convert the filter to lowercase for case-insensitive search
            return Object.values(payment).some((value) => {
              if (value && typeof value === 'string') {
                return value.toLowerCase().includes(searchString);
              }
              return false;
            });
          })
          : PaymentReceipts?.pendingPayments;
        const filteredPending = props.filter != null && props.filter != "all"
          ? firstFilter.filter((payment) => {
            const searchString = props.filter.toLowerCase(); // Convert the filter to lowercase for case-insensitive search
            return Object.values(payment).some((value) => {
              if (value && typeof value === 'string') {
                return value.toLowerCase().includes(searchString);
              }
              return false;
            });
          })
          : firstFilter;

        const amountArray = filteredPending?.map((account) => {
          return { amountTopay: account.amountDue, id: account?.id };
        });

        setAmountToPayArray(amountArray);
        setRows(filteredPending);

        break;

      case 1:
        await PaymentReceipts.getBillHistory({
          errorId: "getBillHistoryError",
          data: {
            from: moment(fromValue).format("YYYY-MM-DD"),
            to: toValue?.toISOString().split("T")[0],
            fullName:
              (General?.codeLabels["cm_pdc_paymentaccounts"]
                ?.languageCode == "ARA"
                ? User?.profile?.arName
                  ? User?.profile?.arName?.trim()?.split(/[,\s]+/)?.slice(0, 3)?.join(' ')
                  : User?.profile?.name?.trim()?.split(/[,\s]+/)?.slice(0, 3)?.join(' ')
                : (User?.profile?.name?.trim()?.split(/[,\s]+/)?.slice(0, 3)?.join(' ') as string)),
          },
        });
        setColumns(billColumns);

        const firstFilterPayment =
          props.selectFilter.payment != null &&
            props.selectFilter.payment != "all"
            ? PaymentReceipts.bills.filter(
              (payment) => payment.paymentStatus == props.selectFilter.payment
            )
            : PaymentReceipts.bills;
        const filteredBills = props.filter != null && props.filter != ""
          ? firstFilterPayment.filter((payment) => {
            const searchString = props.filter.toLowerCase(); // Convert the filter to lowercase for case-insensitive search
            return Object.values(payment).some((value) => {
              if (value && typeof value === 'string') {
                return value.toLowerCase().includes(searchString);
              }
              return false;
            });
          })
          : firstFilterPayment;

        setRows(filteredBills);
        break;

      case 2:
        await PaymentReceipts.getPaymentHistory({
          errorId: "getPaymentHistoryError",
          data: {
            from: moment(fromValue).format("YYYY-MM-DD"),
            to: toValue?.toISOString().split("T")[0],
            fullName:
              (General?.codeLabels["cm_pdc_paymentaccounts"]
                ?.languageCode == "ARA"
                ? User?.profile?.arName
                  ? User?.profile?.arName?.trim()?.split(/[,\s]+/)?.slice(0, 3)?.join(' ')
                  : User?.profile?.name?.trim()?.split(/[,\s]+/)?.slice(0, 3)?.join(' ')
                : (User?.profile?.name?.trim()?.split(/[,\s]+/)?.slice(0, 3)?.join(' ') as string)),
          },
        });
        setColumns(paymemtColumns);
        const filteredHistory: any = props.filter != null && props.filter != ""
          ? PaymentReceipts.payments.filter((payment: any) => {
            const searchString = props.filter.toLowerCase(); // Convert the filter to lowercase for case-insensitive search
            return Object.values(payment).some((value) => {
              if (value && typeof value === 'string') {
                return value.toLowerCase().includes(searchString);
              }
              return false;
            });
          })
          : PaymentReceipts.payments;

        setRows(filteredHistory);
        break;

      case 3:
        await PaymentReceipts.getPostDatedCheques({
          errorId: "getPostDatedChequesError",
          data: {
            from: moment(fromValue).format("YYYY-MM-DD"),
            to: toValue?.toISOString().split("T")[0],
            fullName:
              (General?.codeLabels["cm_pdc_paymentaccounts"]
                ?.languageCode == "ARA"
                ? User?.profile?.arName
                  ? User?.profile?.arName?.trim()?.split(/[,\s]+/)?.slice(0, 3)?.join(' ')
                  : User?.profile?.name?.trim()?.split(/[,\s]+/)?.slice(0, 3)?.join(' ')
                : (User?.profile?.name?.trim()?.split(/[,\s]+/)?.slice(0, 3)?.join(' ') as string)),
          },
        });
        setColumns(postDatedChequesColumns);

        const firstFilterPayment2 =
          props.selectFilter.payment != null &&
            props.selectFilter.payment != "all"
            ? PaymentReceipts.postDatedCheques.filter(
              (payment) => payment.status == props.selectFilter.payment
            )
            : PaymentReceipts.postDatedCheques;
        const filteredReceipts = props.filter != null && props.filter != ""
          ? firstFilterPayment2.filter((payment) => {
            const searchString = props.filter.toLowerCase(); // Convert the filter to lowercase for case-insensitive search
            return Object.values(payment).some((value) => {
              if (value && typeof value === 'string') {
                return value.toLowerCase().includes(searchString);
              }
              return false;
            });
          })
          : firstFilterPayment2;

        setRows(filteredReceipts);
        break;
      case 4:
        await PaymentReceipts.getAccountSummary({
          errorId: "getaccountHistory",
          data: {
            UserName: User.info.userName as string,
          },
        });
        setColumns(summaryColumns);
        const filteredSummary = props.filter != null && props.filter != ""
          ? PaymentReceipts.accountSummary.filter((payment) => {
            const searchString = props.filter.toLowerCase();
            return Object.values(payment).some((value) => {
              if (value && typeof value === 'string') {
                return value.toLowerCase().includes(searchString);
              }
              return false;
            });
          })
          : PaymentReceipts.accountSummary;
        setRows(filteredSummary);
        break;
      default:
        break;
    }

    setTimeout(() => {
      setLoading(false);
    }, 1000);
  };
  // Money on this screen is added up in integer fils (100 fils = 1 dirham) so
  // the totals are exact by construction. Summing the floats directly used to
  // produce amounts such as 368.70000000000005, which the payment gateway
  // rejects ("money supports only 2 decimal places").
  const selectedAmounts = selectedRows.map(
    (row: any) =>
      amountToPayArray.find((item) => item.id === row?.id)?.amountTopay
  );
  const selectedFils = sumFils(selectedAmounts);
  const totalDueFils = sumFils(rows.map((row: any) => row?.amountDue));
  const selectedDueFils = sumFils(
    selectedRows.map((row: any) => row?.amountDue)
  );
  const balanceFils = totalDueFils - selectedFils;

  /**
   * A malformed amount must not be turned into a plausible AED 0.00 payment, so
   * the payment path stops rather than sending a figure we cannot vouch for.
   *
   * The balances of the selected rows are checked too, not just the amounts the
   * user typed: sumFils skips anything it cannot parse, so an unreadable balance
   * would otherwise produce a request the gateway happily accepts carrying a
   * Balance that is wrong or negative - a silent bad figure instead of a loud
   * rejection. Scoped to the selected rows on purpose: an unreadable balance on
   * a row the user is not paying must not lock them out of paying another.
   */
  const hasPayableAmount = () => {
    const selectedBalances = selectedRows.map((row: any) => row?.amountDue);

    if (!areValidAmounts(selectedBalances)) {
      NotifyError(
        General?.codeLabels["cm_invalid_amount"]?.label
          ? General?.codeLabels["cm_invalid_amount"]?.label
          : "Some balances could not be read. Please refresh and try again."
      );
      return false;
    }

    if (!areValidAmounts(selectedAmounts) || selectedFils <= 0) {
      NotifyError(
        General?.codeLabels["cm_invalid_amount"]?.label
          ? General?.codeLabels["cm_invalid_amount"]?.label
          : "Please enter a valid amount to pay."
      );
      return false;
    }
    return true;
  };

  const handlePaymentModal = () => {
    if (!hasPayableAmount()) return;
    setPaymentModal(true);
  };

  const handlePaymentModalClose = () => {
    setPaymentModal(false);
  };
  const [paymentLoader, setPaymentLoader] = useState(false);
  const handlePayNow = async ({
    token,
    cvv,
    type,
    paymentRequestType,
  }: {
    token: string;
    cvv?: string;
    type?: string;
    paymentRequestType?: number;
  }) => {
    if (document.activeElement instanceof HTMLElement) {
      document.activeElement.blur();
    }
    if (!hasPayableAmount()) return;
    setTimeout(async () => {
    setPaymentLoader(true)
    const totalAmountToPay = filsToAmount(totalDueFils);
    const totalAmountSelected = filsToAmount(selectedFils);

    const data = {
      accounts: selectedRows.map((index: any) => {
        return {
          // ...index,
          // isChecked: true,
          CustomerName: index?.customerName,
          Balance: filsToAmount(selectedDueFils - selectedFils), //TODO 7ellaaa
          PremiseDetails: index?.premiseDetails,
          PremiseUsage: index?.premiseDetails,
          AccountId: index?.accountNumber,
          amountToPay: normalizeAmount(
            amountToPayArray.find((ele) => index?.id == ele?.id)?.amountTopay
          ),
          SewerageId: index?.sewerageNumber,
        };
      }),

      platform: "web",
      paymentRequestType,
      cvv: "100",
      personId: User.info.personId,
      personName: User.profile.name,
      status: "Success",
      token,
      acctType: "uos", //"string",
      totalAmountToPay, //check this
      totalAmountSelected, //check this
      email: User.profile.email,
      type,
    };

    const res = await PaymentReceipts.payBill({
      errorId: "payBillError",
      data,
    });
    if (res?.message == "Success") {
      window.open(res?.result?.redirectUrl, "_self");
      setPaymentLoader(false)
    }
    }, 100);
  };
  const handleAmountToPay = (index: number, value: string) => {
    const updatedAmountToPayArray = amountToPayArray.map((item) => {
      if (item.id === index) {
        return { ...item, amountTopay: value };
      }
      return item;
    });

    setAmountToPayArray(updatedAmountToPayArray);
  };

  const totalAmountSelected = filsToAmount(selectedFils);

  useEffect(() => {
    loadTable();

  }, [props.index, fromValue, toValue, props.filter, props.selectFilter]);

  const sharedColumnsBase: GridColDef[] = [
    {
      field: "accountNumber",
      headerName: General?.codeLabels["cm_accountnopaymentstable"]?.label
        ? General?.codeLabels["cm_accountnopaymentstable"]?.label
        : "Account Number",
      headerAlign: "left",
      align: "left",
      flex: 1,
      type: "number",
      editable: false,
    },
    {
      field: "sewerageNumber",
      headerName: General?.codeLabels["cm_seweragenum"]?.label
        ? General?.codeLabels["cm_seweragenum"]?.label
        : "Sewerage Number",
      description: "This column is not sortable.",
      headerAlign: "left",
      sortable: false,
      flex: 1,
    },
    {
      field: "premiseDetails",
      headerName: General?.codeLabels["cm_pdc_premisedetails"]?.label
        ? General?.codeLabels["cm_pdc_premisedetails"]?.label
        : "Premise Details",
      headerAlign: "left",
      flex: 1,
      description: "This column is a text & is not sortable.",
      sortable: false,
    },
  ];
const totalAmount = filsToAmount(totalDueFils);

  const accountsPayload = selectedRows.map((index: any) => {
    return {
        CustomerName: index?.customerName,
        Balance: filsToAmount(selectedDueFils - selectedFils),
        PremiseDetails: index?.premiseDetails,
        PremiseUsage: index?.premiseDetails,
        AccountId: index?.accountNumber,
        amountToPay: normalizeAmount(
            amountToPayArray.find((ele) => index?.id == ele?.id)?.amountTopay
        ),
        SewerageId: index?.sewerageNumber,
    };
});

const paymentDataForGateway = {
    accounts: accountsPayload,
    totalAmountToPay: totalAmount,
    totalAmountSelected: totalAmountSelected,
    platform: "web",
    email: User.profile.email,
    personId: User.info.personId,
    personName: User.profile.name,
    acctType: "uos", 
    amount: totalAmountSelected, 
    token:"",
    type: "",
    paymentRequestType: 1,
    returnUrl:`${window.location.origin}/Payment/ExternalRedirect`, 
    //  returnUrl:`http://192.168.220.241:8909/Payment/ExternalRedirect`, 
    status:"",
    tokenNumber:"",
    corelationID:""

};

const handleBillPaymentInitiation = async (payload: any, gatewayType:string) => {
  if(gatewayType === 'ni'){
const res = await PaymentReceipts.payBillNI({
      errorId: "payBillError",
      data: payload,
    });

    if (res?.message === "Success") {
      return res; 
    } else {
      throw new Error(res?.message || "Bill Payment initiation failed.");
    }
  }
  if(gatewayType === 'tabby'){    
    const res = await PaymentReceipts.payBillTabby({
      errorId: "payBillError",
      data: payload,
    });

    if (res?.message === "Success") {
      return res; 
    } else {
      throw new Error(res?.message || "Bill Payment initiation failed.");
    }
  }
  if(gatewayType === 'tamara'){    
    const res = await PaymentReceipts.payBillTamara({
      errorId: "payBillError",
      data: payload,
    });

    if (res?.message === "Success") {
      return res; 
    } else {
      throw new Error(res?.message || "Bill Payment initiation failed.");
    }
  }
    
};
const checkTabbyEligibility = async (payload: any) => {
  try {
    const response = await PaymentReceipts.makeTabbyEligibilityCheck({
            errorId: "tabbyEligibilityCheckError",
            data: payload,
          });
    // return !!response?.result?.isEligible;
    const isEligible = !!response?.result?.isEligible;
    const message = response?.result?.message || "";
    const isAmountEligible = response?.result?.isAmountEligible;

    return { isEligible, message, isAmountEligible };
  } catch (error) {
    console.error("Eligibility check failed:", error);
    return false;
  }
};

const checkTamaraEligibility = async (payload: any) => {
  try {
    const response = await nocsRequestsStore.makeTamaraEligibilityCheck({
            errorId: "tamaraEligibilityCheckError",
            data: payload,
          });
    const message = response?.result?.message || "";
const isAmountEligible = response?.result?.isAmountEligible;

    return {message, isAmountEligible };
  } catch (error) {
    console.error("Tamara eligibility check failed:", error);
    return false;
  }
};

  const sharedColumns: GridColDef[] = [
    {
      field: "paymentDate",
      headerName: General?.codeLabels["cm_billdatedatatable"]?.label ? General?.codeLabels["cm_billdatedatatable"]?.label : "Bill Date",
      headerAlign: "left",
      align: "left",
      flex: 1,
    },
    {
      field: "paymentReference",
      headerName: General?.codeLabels["cm_billeventidtable"]?.label ? General?.codeLabels["cm_billeventidtable"]?.label : "Bill Reference",
      headerAlign: "left",
      align: "left",
      flex: 1,
      type: "number",
      editable: false,
    },
    {
      field: "accountNumber",
      headerName: General?.codeLabels["cm_accountnopaymentstable"]?.label
        ? General?.codeLabels["cm_accountnopaymentstable"]?.label
        : "Account Number",
      headerAlign: "left",
      align: "left",
      flex: 1,
      type: "number",
      editable: false,
    },
    {
      field: "premiseDetails",
      headerName: General?.codeLabels["cm_pdc_premisedetails"]?.label
        ? General?.codeLabels["cm_pdc_premisedetails"]?.label
        : "Premise Details",
      headerAlign: "left",
      align: "left",
      flex: 1,
      description: "This column is a text & is not sortable.",
      sortable: false,
    },
    // {
    //   field: "customerName",
    //   headerName: General?.codeLabels["cm_noccustomername"]?.label
    //     ? General?.codeLabels["cm_noccustomername"]?.label
    //     : "Customer Name",
    //   flex: 1,
    //   headerAlign: "left",
    //   align: "left",
    //   description: "This column is a text & is not sortable.",
    //   sortable: false,
    // },
  ];

  const pendingColumns: GridColDef[] = [
    {
      field: "accountNumber",
      headerName: General?.codeLabels["cm_accountnopaymentstable"]?.label
        ? General?.codeLabels["cm_accountnopaymentstable"]?.label
        : "Account Number",
      headerAlign: "left",
      align: "left",
      flex: 1,
      type: "number",
      editable: false,
    },
    {
      field: "sewerageNumber",
      headerName: General?.codeLabels["cm_seweragenum"]?.label
        ? General?.codeLabels["cm_seweragenum"]?.label
        : "Sewerage Number",
      description: "This column is not sortable.",
      headerAlign: "left",
      align: 'left',
      sortable: false,
      flex: 1,
    },
    {
      field: "premiseDetails",
      headerName: General?.codeLabels["cm_pdc_premisedetails"]?.label
        ? General?.codeLabels["cm_pdc_premisedetails"]?.label
        : "Premise Details",
      headerAlign: "left",
      align: 'left',
      flex: 1,
      description: "This column is a text & is not sortable.",
      sortable: false,
    },
    {
      field: "premiseType",
      headerName: General?.codeLabels["cm_premise_type"]?.label
        ? General?.codeLabels["cm_premise_type"]?.label
        : "Premise Type",
      description: "This column is not sortable.",
      headerAlign: "left",
      align: 'left',
      sortable: false,
      flex: 1,
    },
    {
      field: "type",
      headerName: General?.codeLabels["cm_type"]?.label
        ? General?.codeLabels["cm_type"]?.label
        : "Type",
      description: "This column is not sortable.",
      headerAlign: "left",
      align: 'left',
      sortable: false,
      flex: 1,
    },
    // {
    //   field: "customerName",
    //   headerName: General?.codeLabels["cm_noccustomername"]?.label
    //     ? General?.codeLabels["cm_noccustomername"]?.label
    //     : "Customer Name",
    //   description: "This column is not sortable.",
    //   sortable: false,
    //   headerAlign: "left",
    //   align: 'left',
    //   flex: 1,
    // },
    // {
    //   field: "Bill",
    //   headerName: General?.codeLabels["cm_bill"]?.label
    //     ? General?.codeLabels["cm_bill"]?.label
    //     : "Bill",
    //   headerAlign: "left",
    //   flex: 1,
    //   sortable: false,

    //   renderCell: (params: any) => {
    //     return (
    //       <>
    //         <div>
    //           {!Object.fromEntries(Object.entries(params.row).map((a) => a))
    //             .lastBillId ? (
    //             "N/A"
    //           ) : (
    //             <img
    //             style={{cursor:'pointer'}}
    //               src={pdf}
    //               onClick={() => {
    //                 setLastBillingId(
    //                   Object.fromEntries(
    //                     Object.entries(params.row).map((a) => a)
    //                   ).lastBillId
    //                 );
    //                 downloadBillPDF(lastBillingId.toString());
    //               }}
    //               alt="PDF"
    //             />
    //           )}
    //         </div>
    //       </>
    //     );
    //   },
    // },
    {
      field: "amountDue",
      headerName: `${General?.codeLabels["cm_amt_due"]?.label
        ? General?.codeLabels["cm_amt_due"]?.label
        : "Amount Due"} `,
      description: "This column is not sortable.",
      sortable: false,
      flex: 1,
      headerAlign: "right",
      align: 'right',
    },

    {
      field: "amountToPay",
      headerName: `${General?.codeLabels["cm_amttopay"]?.label
        ? General?.codeLabels["cm_amttopay"]?.label
        : "Amount to Pay"} `,
      description: "This column is not sortable.",
      sortable: false,
      editable: true,
      flex: 1,
      headerAlign: "right",
      align: 'right',
    },
  ];

  const billColumns: GridColDef[] = [
    ...sharedColumns,
    // {
    //   field: "paymentStatus",
    //   headerName: General?.codeLabels["cm_bill_status"]?.label ? General?.codeLabels["cm_bill_status"]?.label : "Bill Status",
    //   headerAlign: "left",
    //   align: 'left',
    //   flex: 1,
    //   description: "This column is not sortable.",
    //   sortable: false,
    // },
    {
      field: "Bill",
      headerName: General?.codeLabels["cm_bill"]?.label
        ? General?.codeLabels["cm_bill"]?.label
        : "Bill",
      headerAlign: "left",
      align: "left",
      flex: 1,
      sortable: false,
      renderCell: (params: any) => {
        console.log(toJS(params));
        return (
          <>
            <div onClick={() => downloadBillPDF(params.row.paymentReference)}>
              <img style={{ cursor: 'pointer' }} src={pdf} alt="" />
            </div>
          </>
        );
      },
    },
  ];

  const paymemtColumns: GridColDef[] = [
    {
      field: "paymentDate",
      headerName: General?.codeLabels["cm_paymentdatedatatable"]?.label ? General?.codeLabels["cm_paymentdatedatatable"]?.label : "Payment Date",
      headerAlign: "left",
      align: "left",
      flex: 1,
    },
    {
      field: "paymentReference",
      headerName: General?.codeLabels["cm_payment_referenceno"]?.label ? General?.codeLabels["cm_payment_referenceno"]?.label : "Payment Reference",
      headerAlign: "left",
      align: "left",
      flex: 1,
      type: "number",
      editable: false,
    },
    {
      field: "accountNumber",
      headerName: General?.codeLabels["cm_accountnopaymentstable"]?.label
        ? General?.codeLabels["cm_accountnopaymentstable"]?.label
        : "Account Number",
      headerAlign: "left",
      align: "left",
      flex: 1,
      type: "number",
      editable: false,
    },
    {
      field: "premiseDetails",
      headerName: General?.codeLabels["cm_pdc_premisedetails"]?.label
        ? General?.codeLabels["cm_pdc_premisedetails"]?.label
        : "Premise Details",
      headerAlign: "left",
      align: "left",
      flex: 1,
      description: "This column is a text & is not sortable.",
      sortable: false,
    },
    // {
    //   field: "customerName",
    //   headerName: General?.codeLabels["cm_noccustomername"]?.label
    //     ? General?.codeLabels["cm_noccustomername"]?.label
    //     : "Customer Name",
    //   flex: 1,
    //   headerAlign: "left",
    //   align: "left",
    //   description: "This column is a text & is not sortable.",
    //   sortable: false,
    // },
    {
      field: "paidAmount",
      headerName: `${General?.codeLabels["cm_paid_am"]?.label
        ? General?.codeLabels["cm_paid_am"]?.label
        : "Paid Amount"} `,
      headerAlign: "left",
      width: 150,
      // flex:1,
      align: "right",

    },
    {
      field: "Receipt",
      headerName: General?.codeLabels["cm_receipt"]?.label
        ? General?.codeLabels["cm_receipt"]?.label
        : "Receipt",
      headerAlign: "left",
      flex: 1,
      align: "left",
      sortable: false,
      renderCell: (params: any) => {
        return (
          <>
            <div
              onClick={() =>
                downloadPaymentHistoryPdf(params.row.paymentReference)
              }
            >
              <img style={{ cursor: 'pointer' }} src={pdf} alt="" />
            </div>
          </>
        );
      },
    },
  ];

  const summaryColumns: any[] = [
    {
      field: "paymentDate",
      headerName: General?.codeLabels["cm_asreqdatedatatable"]?.label
        ? General?.codeLabels["cm_asreqdatedatatable"]?.label
        : "Creation Date",
      headerAlign: "left",
      align: "left",
      flex: 1, // Take full width by default
      minWidth: 150, // Set a minimum width for smaller screens
    },
    {
      field: "reportId",
      headerName: General?.codeLabels["cm_report_id"]?.label
        ? General?.codeLabels["cm_report_id"]?.label
        : "Report Id",
      headerAlign: "left",
      align: "left",
      display: "none",
      flex: 1, // Take full width by default
      minWidth: 100, // Set a minimum width for smaller screens
    },
    {
      field: "type",
      headerName: General?.codeLabels["cm_type"]?.label ? General?.codeLabels["cm_type"]?.label : "Type",
      headerAlign: "left",
      align: "left",
      flex: 1, // Take full width by default
      minWidth: 100, // Set a minimum width for smaller screens
      description: "This column is not sortable.",
      sortable: false,
    },
    {
      field: "paymentStatus",
      headerName: General?.codeLabels["cm_noc_status"]?.label ? General?.codeLabels["cm_noc_status"]?.label : "Status",
      headerAlign: "left",
      align: "left",
      flex: 1, // Take full width by default
      minWidth: 100, // Set a minimum width for smaller screens
      description: "This column is not sortable.",
      sortable: false,
    },
    {
      field: "Receipt",
      headerName: General?.codeLabels["cm_asdownloaddatatable"]?.label ? General?.codeLabels["cm_asdownloaddatatable"]?.label : "Download File",
      headerAlign: "left",
      flex: 1, // Take full width by default
      minWidth: 170, // Set a minimum width for smaller screens
      align: "left",
      sortable: false,
      renderCell: (params: any) => {
        return (
          <>
            {params.row.paymentStatus == 'Complete' && <div
              onClick={() =>
                downloadAccountSummaryPdf(params.row.reportId, params.row.type)
              }
            >
              <img style={{ cursor: 'pointer' }} src={pdf} alt="" />
            </div>}
          </>
        );
      },
    },
  ];

  const postDatedChequesColumns: GridColDef[] = [
    {
      field: "accountNumber",
      headerName: General?.codeLabels["cm_accountnopaymentstable"]?.label
        ? General?.codeLabels["cm_accountnopaymentstable"]?.label
        : "Account Number",
      headerAlign: "left",
      align: "left",
      flex: 1,
      type: "number",
      editable: false,
    },
    {
      field: "sewerageNumber",
      headerName: General?.codeLabels["cm_pdc_paymentplanid"]?.label
        ? General?.codeLabels["cm_pdc_paymentplanid"]?.label
        : "Sewerage Number",
      description: "This column is not sortable.",
      headerAlign: "left",
      align: 'left',
      sortable: false,
      flex: 1,
    },
    {
      field: "premiseDetails",
      headerName: General?.codeLabels["cm_pdc_premisedetails"]?.label
        ? General?.codeLabels["cm_pdc_premisedetails"]?.label
        : "Premise Details",
      headerAlign: "left",
      align: 'left',
      flex: 1,
      description: "This column is a text & is not sortable.",
      sortable: false,
    },

    {
      field: "createdDate",
      align: "left",
      headerAlign: 'left',
      flex: 1,
      headerName: General?.codeLabels["cm_pdctablecreateddate"]?.label ? General?.codeLabels["cm_pdctablecreateddate"]?.label : "Created Date",
    },
    {
      field: "chqDate",
      headerAlign: 'left',
      align: 'left',
      flex: 1,
      headerName: General?.codeLabels["cm_cheq_date"]?.label ? General?.codeLabels["cm_cheq_date"]?.label : "Chq Date",
    },
    {
      field: "chqNumber",
      headerAlign: "left",
      align: 'left',
      flex: 1,
      headerName: General?.codeLabels["cm_cheq_no"]?.label ? General?.codeLabels["cm_cheq_no"]?.label : "Chq Number",
    },
    {
      field: "bankNameAccount",
      headerName: General?.codeLabels["cm_bankname"]?.label ? General?.codeLabels["cm_bankname"]?.label : "Bank Name",
      description: "This column is not sortable.",
      headerAlign: "left",
      align: "left",
      flex: 1,
      sortable: false,
    },
    {
      field: "chqAmount",
      headerName: General?.codeLabels["cm_pdc_chequeamount"]?.label ? General?.codeLabels["cm_pdc_chequeamount"]?.label : "Chq Amount",
      headerAlign: "left",
      align: "right",
      flex: 1,
    },
    {
      field: "status",
      flex: 1,
      headerAlign: "left",
      align: "left",
      headerName: General?.codeLabels["cm_pdc_status"]?.label
        ? General?.codeLabels["cm_pdc_status"]?.label
        : "Status",
      description: "This column is not sortable.",
    },
    {
      field: "Receipt",
      headerName: General?.codeLabels["cm_asdownloaddatatable"]?.label ? General?.codeLabels["cm_asdownloaddatatable"]?.label : "Download File",
      headerAlign: "left",
      flex: 1, // Take full width by default
      // minWidth: 170, // Set a minimum width for smaller screens
      align: "left",
      sortable: false,
      renderCell: (params: any) => {
        return (
          <>
            <div
              onClick={() =>
                downloadPDCFile(params.row.ppId, 'PDC')
              }
            >
              <img style={{ cursor: 'pointer' }} src={pdf} alt="" />
            </div>
          </>
        );
      },
    },
  ];

  const ColorAss = General?.ColorAss;
  const contrast = General?.contrast;
  return (
    <>
      <Box
        sx={{
          height: "80vh",
          width: isLargeScreen ? "94%" : "100%",
          backgroundColor: contrast?.contrastBackground
            ? contrast?.contrastBackground
            : "white",
          color: contrast?.contrastColor ? contrast?.contrastColor : ColorAss,
          margin: "auto",
          paddingInline: "0px",
          overflow: 'auto',
        }}
      >
        <Box
          sx={{
            width: props?.OtherWidth ?? "96%",
            paddingTop: "2rem",
            paddingBottom: "2rem",
            display: "flex",
            flexDirection: isLargeScreen ? "row" : "column",
            justifyContent: "space-between",
            gap: {
              xs: "20px",
              md: "0px",
            },
            margin: "auto",
          }}
        >
          <Box
            className=""
            id={"dateContainers"}
            sx={{
              display: props.index !== 0 ? "flex" : "flex",
              flex: 3,
              gap: "1rem",
              height: { xs: 0, md: "3rem" },
            }}
          >
            {props.index !== 0 && props.index !== 4 ? (
              <Box
                sx={{
                  display: "flex",
                  width: {
                    xs: "100%",
                    lg: "200px",
                  },
                  alignItems: "center",
                  flexDirection: { xs: "row", md: "row", sm: "row" }, // Change to column below xs (768px)
                  gap: {
                    xs: "8px",
                    md: "0px",
                  },
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    width: "100%",
                    gap: {
                      xs: "8px",
                      md: "0px",
                    },
                  }}
                >
                  <Box
                    sx={{
                      fontSize: `${0.75 * General.accessibility.fontSize}rem`,
                      marginInlineEnd: {
                        xs: "0px",
                        md: "10px",
                      },
                      color: General.contrast.contrastColor
                        ? General.contrast.contrastColor
                        : General?.colorClass,
                    }}
                    className="calendarItems pt-lg-0 pt-0"
                  >
                    {General?.codeLabels["cm_from"]?.label || "From"}
                  </Box>
                  <LocalizationProvider dateAdapter={AdapterMoment}>
                    <MobileDatePicker
                      disableFuture={true}
                      className="calendar-style"
                      inputFormat="DD-MM-YYYY"
                      value={fromValue}
                      onChange={handleFromChange}
                      renderInput={(params: TextFieldProps) => {
                        return (
                          <TextField 
                          sx={{
                            width:General?.isLargeScreen ? '200px':'140px'
                          }}
                          className="text-field-cal" {...params} />
                        );
                      }}
                    />
                  </LocalizationProvider>
                </Box>

                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    width: "100%",
                    gap: {
                      xs: "10px",
                      md: "0px",
                    },
                    marginRight: { xs: '0.5rem' }
                  }}
                >
                  <span
                    className="calendarItems pt-lg-0 pt-1 px-2 "
                    style={{
                      marginLeft: isLargeScreen ? "10px" : "",
                      fontSize: `${0.75 * General.accessibility.fontSize}rem`,
                      color: General.contrast.contrastColor
                        ? General.contrast.contrastColor
                        : General?.ColorAss,
                    }}
                  >
                    {General?.codeLabels["cm_to"]?.label || "To"}
                  </span>
                  <LocalizationProvider dateAdapter={AdapterMoment}>
                    <MobileDatePicker
                      disableFuture={true}
                      className="calendar-style"
                      inputFormat="DD-MM-YYYY"
                      value={toValue}
                      onChange={handleToChange}
                      renderInput={(params: TextFieldProps) => {
                        return <TextField 
                        sx={{
                          width:General?.isLargeScreen ? '200px':'140px'
                        }}
                        {...params} />;
                      }}
                    />
                  </LocalizationProvider>
                </Box>
              </Box>
            ) : (
              props.children
            )}
          </Box>

          {props.children2}
        </Box>

        {isLargeScreen ? (
          loading ? (
            <Spinner />
          ) : (
            <DataGrid
              loading={loading}
              rows={rows}
              autoHeight={true}
              checkboxSelection={props?.checkboxSelection}
              columns={columns}
              hideFooter={true}
              disableSelectionOnClick={true}
              onSelectionModelChange={(ids) => handleRowSelection(ids)}
              onCellEditCommit={(
                params: GridCellEditCommitParams,
                event: MuiEvent
              ) => {
                handleAmountToPay(params.id as number, params.value);
              }}
              sx={{
                "& .MuiDataGrid-columnSeparator": { display: "none" },

                color: contrast?.contrastColor ? contrast?.contrastColor : General?.ColorAss,
                width: props?.datagridWidth ?? "96%",
                "@media screen and (max-width: 768px)": {
                  width: "100%", // Adjust width for smaller screens
                },
                height: "65vh",
                margin: "auto",
                border: "none",
                "& .MuiSvgIcon-root": {
                  color: General.contrast.contrastColor
                    ? General.contrast.contrastColor
                    : General?.ColorAss,
                },
                "& .MuiDataGrid-sortIcon": {
                  color: contrast?.contrastBackground
                    ? contrast?.contrastBackground
                    : General?.ColorAss,
                },
                "& .MuiDataGrid-columnHeaderTitle": {
                  fontWeight: "bolder !important",
                },
                "& .MuiDataGrid-cell,.MuiDataGrid-row": {
                  whiteSpace: "normal !important",
                },
                "& .MuiDataGrid-columnHeaders": {
                  display: "flex",
                  justifyContent: "space-between",
                  backgroundColor: props?.tabBackgroundColor ?? "#E5EFF2",
                  fontSize: `${0.875 * General.accessibility.fontSize}rem`,
                },
                "& .MuiDataGrid-columnHeadersInner": {
                  color: contrast?.contrastBackground
                    ? contrast?.contrastBackground
                    : General?.ColorAss,
                  background: contrast?.contrastColor
                    ? contrast?.contrastColor
                    : "FFFFFF",
                },
                "& .Mui-selected": {
                  backgroundColor: contrast?.contrastBackground
                    ? contrast?.contrastBackground
                    : "#E5EFF2",
                  color: contrast?.contrastColor ? contrast?.contrastColor : "",
                },
                "& .MuiButtonBase-root ": {
                  color: General.contrast.contrastColor
                    ? General.contrast.contrastColor
                    : General?.ColorAss,
                },
                "& .MuiDataGrid-cellContent": {
                  fontSize: `${0.875 * General.accessibility.fontSize}rem`,
                  color: contrast?.contrastColor ? contrast?.contrastColor : General?.ColorAss,
                },

                '[data-field="amountToPay"]': {
                  margin: "auto",
                  "& .MuiDataGrid-cellContent": {
                    backgroundColor: contrast?.contrastBackground
                      ? contrast?.contrastBackground
                      : "#E5EFF2",
                    color: contrast?.contrastColor
                      ? contrast?.contrastColor
                      : "",
                    textAlign: "right",
                    width: "100px",
                    height: "100%",
                    padding: "5px",
                    border: "1px solid lightgray",
                    // fontSize:'2rem'
                  },
                },
              }}
            />
          )
        ) : loading ? (
          <Spinner />
        ) : (
          <MobileDataGrid
            downloadPDCFile={downloadPDCFile}
            downloadBillPDF={downloadBillPDF}
            downloadPaymentHistoryPdf ={downloadPaymentHistoryPdf}
            downloadAccountSummaryPdf={downloadAccountSummaryPdf}
            rows={rows}
            indexes={props.index}
            handleAmountToPay={handleAmountToPay}
            handleRowSelection={handleRowSelection}
            amountToPayArray={amountToPayArray}
            selectedRows={selectedRows}
            checkboxSelection={props?.checkboxSelection}
          />
        )}

        {props.index == 0 ? (
          <div
            className="mb-2"
            style={{
              marginLeft: isLargeScreen ? "26px" : "0px",
              width: isLargeScreen ? "96%" : "100%",
              background: contrast?.contrastBackground
                ? contrast?.contrastBackground
                : " rgba(229, 239, 242, 0.7)",
              height: "60px",
              marginBottom: "0px",
            }}
          >
            <div style={{ display: "flex", justifyContent: "end" }}>
              <div
                style={{
                  minWidth: isLargeScreen ? "30%" : "60%",
                  display: "flex",
                  justifyContent: "space-around",
                }}
              >
                <p
                  style={{
                    margin: "0",
                    display: "flex",
                    alignItems: "center",
                    height: "40px",
                    padding: "20px",
                    marginTop: "10px",
                    fontWeight: "700",
                    fontSize: `${0.875 * General.accessibility.fontSize}rem`,
                    lineHeight: "16px",
                    color: General.contrast.contrastBackground
                      ? General.contrast.contrastBackground
                      : General?.ColorAss,
                    background: General.contrast.contrastColor
                      ? General.contrast.contrastColor
                      : "#fff",
                  }}
                >
                  <span
                    className="py-2 px-3"
                    style={{ backgroundColor: "" }}
                  >
                    {" "}
                    {General?.codeLabels["cm_pay_total_due"]?.label
                      ? General?.codeLabels["cm_pay_total_due"]?.label
                      : "Total Due AED"}&nbsp;
                    {formatFils(totalDueFils)}
                  </span>
                </p>
                <p
                  style={{
                    margin: "0",
                    display: "flex",
                    alignItems: "center",
                    height: "40px",
                    padding: "20px",
                    marginTop: "10px",
                    fontWeight: "700",
                    fontSize: `${0.875 * General.accessibility.fontSize}rem`,
                    lineHeight: "16px",
                    color: General.contrast.contrastBackground
                      ? General.contrast.contrastBackground
                      : General?.ColorAss,
                    background: General.contrast.contrastColor
                      ? General.contrast.contrastColor
                      : "#fff",
                  }}
                >
                  <span
                    className="py-2 px-3"
                    style={{ backgroundColor: "" }}
                  >
                    {formatFils(selectedFils)}
                  </span>
                </p>
              </div>
            </div>
          </div>
        ) : null}

        {props.index == 0 ? (
          <div
            style={{
              justifyContent: "end",
              display: isLargeScreen ? "flex" : "block",
              width: "96%",
              margin: "auto",
              marginBottom: 10,
              gap: 24,
            }}
          >
            <div
              style={{
                display: "flex",
                width: "100%",
                flexDirection: isLargeScreen ? "column" : "row",
                alignItems: isLargeScreen ? "end" : "center",
                justifyContent: isLargeScreen ? "" : "end",
                fontWeight: "700",
                fontSize: `${General.accessibility.fontSize}rem`,
                gap: "0.5rem",
                backgroundColor: contrast?.contrastBackground
                  ? contrast?.contrastBackground
                  : "",
                color: General.contrast.contrastColor
                  ? General.contrast.contrastColor
                  : General?.ColorAss,
                marginRight: "2rem",
              }}
            >
              <div
                className="pr-1 py-lg-0 py-4 "
                style={{
                  display: "flex",
                  flexDirection: isLargeScreen ? "column" : "row",
                  alignItems: "center",
                  justifyContent: "center",
                  paddingRight: isLargeScreen ? "" : "1rem",

                }}
              >
                <div
                  style={{
                    fontWeight: "700",
                    fontSize: `${General.accessibility.fontSize}rem`,
                    lineHeight: "16px",
                  }}
                >
                  {General?.codeLabels["cm_balance"]?.label
                    ? General?.codeLabels["cm_balance"]?.label
                    : "cm_balance"}
                </div>
                <div
                  style={{
                    fontWeight: "700",
                    fontSize: `${General.accessibility.fontSize}rem`,
                    alignSelf: "flex-end",
                    marginLeft: isLargeScreen ? "" : "1rem",
                  }}
                >
                  {formatFils(balanceFils)}
                </div>
              </div>
            </div>
            <ButtonSecondary
              onClick={()=>{
                if (document.activeElement instanceof HTMLElement) {
      document.activeElement.blur();
    }
    setTimeout(() => {
      handlePaymentModal();
    }, 100);
  }}
              
              disabled={selectedFils > 0 ? false : true}
              style={{
                fontSize: `${General.accessibility.fontSize}rem`,
                color: General.contrast.contrastColor
                  ? General.contrast.contrastBackground
                  : '#fff',
                background: General.contrast.contrastBackground
                  ? General.contrast.contrastColor
                  : General?.ColorAss,
                margin: isLargeScreen ? "" : "14px 0 0 0",
                width: isLargeScreen ? "175px" : "100%",
                height: "50px",
                opacity: selectedFils > 0 ? "1" : '0.5',
                whiteSpace: 'nowrap'
              }}
            //className="DynamicButtonColor"
            >
              {General?.codeLabels["cm_paynow"]?.label
                ? General?.codeLabels["cm_paynow"]?.label
                : "PAY NOW"}
            </ButtonSecondary>
          </div>
        ) : null}
      </Box>
      <Modal
        open={paymentModal}
        onClose={(event, reason) => {
                    if (reason === "backdropClick") return;
                    handlePaymentModalClose();
                  }}
        disableEscapeKeyDown
      >
        {config?.isCheckout ?(<CardsPopup
          onClose={handlePaymentModalClose}
          makePayment={handlePayNow}
          fromAutoPay={false}
          paymentLoader={paymentLoader}
        />):(<GatewaySelection
          onClose={handlePaymentModalClose}
          paymentData={paymentDataForGateway}
          handlePayment={handleBillPaymentInitiation}
          user={User} 
          checkTabbyEligibility={checkTabbyEligibility}
          checkTamaraEligibility={checkTamaraEligibility}
        />)}
      </Modal>
    </>
  );
};

export default observer(DG);

